import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BlogPost, BlogTopic } from '@app/model/blog-content.model';
import { BlogContentDataService } from '@app/services/blog-content-data.service';
import { map, switchMap } from 'rxjs/operators';

interface BlogPostListView {
  title: string;
  description: string;
  category: BlogTopic | null;
  parentCategory: BlogTopic | null;
  childCategories: BlogTopic[];
  posts: BlogPost[];
}

@Component({
  selector: 'meu-blog-list',
  templateUrl: './blog-list.component.html',
  styleUrls: ['./blog-list.component.scss']
})
export class BlogListComponent implements OnInit {
  title = 'Tất cả bài viết';
  description = '';

  category: BlogTopic | null = null;
  parentCategory: BlogTopic | null = null;
  childCategories: BlogTopic[] = [];
  posts: BlogPost[] = [];
  @ViewChild('pageNumberInput', { static: false })
  pageNumberInput: ElementRef<HTMLInputElement>;

  pageSize = 12;
  pageIndex = 1;
  isEditingPage = false;

  constructor(
    private route: ActivatedRoute,
    private blogContentDataService: BlogContentDataService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  private refreshView(): void {

    try {
      this.changeDetectorRef.detectChanges();
    } catch (error) {
      
    }
  }

  get totalPages(): number {
    const posts = Array.isArray(this.posts) ? this.posts : [];

    return Math.ceil(posts.length / this.pageSize);
  }

  get visiblePages(): number[] {
    const maxVisiblePages = 5;

    let startPage = Math.max(1, this.pageIndex - Math.floor(maxVisiblePages / 2));

    let endPage = Math.min(this.totalPages, startPage + maxVisiblePages - 1);

    startPage = Math.max(1, endPage - maxVisiblePages + 1);

    return Array.from(
      {
        length: Math.max(0, endPage - startPage + 1)
      },
      (_, index) => startPage + index
    );
  }

  ngOnInit(): void {
    this.route.paramMap
      .pipe(
        switchMap((params) => {
          const parentSlug = params.get('parentSlug');
          const childSlug = params.get('childSlug');

          if (parentSlug) {
            return this.blogContentDataService
              .getCategoryContent(parentSlug, childSlug || undefined)
              .pipe(
                map(
                  (content): BlogPostListView => ({
                    title: content.category.title,
                    description: content.category.description,
                    category: content.category,
                    parentCategory: content.parentCategory,
                    childCategories: content.childCategories,
                    posts: content.posts
                  })
                )
              );
          }

          return this.blogContentDataService.getAllPosts().pipe(
            map(
              (posts): BlogPostListView => ({
                title: 'Tất cả bài viết',
                description: '',
                category: null,
                parentCategory: null,
                childCategories: [],
                posts
              })
            )
          );
        })
      )
      .subscribe({
        next: (content) => {
          this.title = content.title;
          this.description = content.description;
          this.category = content.category;
          this.parentCategory = content.parentCategory;

          this.childCategories = Array.isArray(content.childCategories)
            ? content.childCategories
            : [];

          this.posts = Array.isArray(content.posts) ? content.posts : [];

          this.pageIndex = 1;
          this.isEditingPage = false;

          this.refreshView();
        },

        error: (error) => {
          console.error('Load blog category failed:', error);

          this.category = null;
          this.parentCategory = null;
          this.childCategories = [];
          this.posts = [];
          this.pageIndex = 1;
          this.isEditingPage = false;

          this.refreshView();
        }
      });
  }

  goToPage(page: number | string): void {
    const parsedPage = Number(page);

    if (isNaN(parsedPage)) {
      this.cancelPageEdit();
      return;
    }

    const lastPage = this.totalPages || 1;

    this.pageIndex = Math.min(Math.max(Math.floor(parsedPage), 1), lastPage);

    this.isEditingPage = false;

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  startPageEdit(): void {
    this.isEditingPage = true;

    setTimeout(() => {
      if (!this.pageNumberInput) {
        return;
      }

      this.pageNumberInput.nativeElement.focus();
      this.pageNumberInput.nativeElement.select();
    });
  }

  cancelPageEdit(): void {
    this.isEditingPage = false;
  }
}
